export async function shareRecordImage({ exercice, muscle, poids, reps, volume, date, name, unit }) {
  try {
    await document.fonts.load('100px "Bebas Neue"');
  } catch (e) {
    console.warn("Police Bebas Neue non chargée:", e?.message);
  }
  const W = 1080, H = 1080;
  const c = document.createElement("canvas");
  c.width = W; c.height = H;
  const ctx = c.getContext("2d");

  ctx.fillStyle = "#0A0A0A";
  ctx.fillRect(0, 0, W, H);
  ctx.strokeStyle = "#FF3B30";
  ctx.lineWidth = 14;
  ctx.strokeRect(40, 40, W - 80, H - 80);
  ctx.fillStyle = "#FF3B30";
  ctx.fillRect(90, 200, 140, 12);

  ctx.textBaseline = "top";
  ctx.fillStyle = "#FFFFFF";
  ctx.font = '90px "Bebas Neue", sans-serif';
  ctx.fillText("GYM", 90, 90);
  const w1 = ctx.measureText("GYM").width;
  ctx.fillStyle = "#FF3B30";
  ctx.fillText("TRACK", 90 + w1, 90);

  ctx.fillStyle = "#FFC107";
  ctx.font = '54px "Bebas Neue", sans-serif';
  ctx.fillText("🏆 RECORD PERSONNEL", 90, 260);

  ctx.fillStyle = "#FFFFFF";
  ctx.font = '110px "Bebas Neue", sans-serif';
  const words = exercice.toUpperCase().split(" ");
  let line = "", y = 360;
  for (const w of words) {
    if (ctx.measureText(line + w).width > W - 200 && line) {
      ctx.fillText(line.trim(), 90, y);
      y += 110;
      line = "";
    }
    line += w + " ";
  }
  ctx.fillText(line.trim(), 90, y);
  y += 130;

  ctx.fillStyle = "#888888";
  ctx.font = "36px Arial, sans-serif";
  ctx.fillText(muscle.toUpperCase(), 90, y);
  y += 90;

  ctx.fillStyle = "#FF3B30";
  ctx.font = '220px "Bebas Neue", sans-serif';
  ctx.fillText(`${poids}`, 90, y);
  const wNum = ctx.measureText(`${poids}`).width;
  ctx.fillStyle = "#FFFFFF";
  ctx.font = '80px "Bebas Neue", sans-serif';
  ctx.fillText(unit.toUpperCase(), 110 + wNum, y + 120);

  y += 260;
  ctx.fillStyle = "#CCCCCC";
  ctx.font = "40px Arial, sans-serif";
  ctx.fillText(`${reps} reps max  ·  ${Math.round(volume)} ${unit} de volume`, 90, y);

  ctx.fillStyle = "#666666";
  ctx.font = "34px Arial, sans-serif";
  ctx.fillText(`${name}  ·  ${date}`, 90, H - 130);

  const blob = await new Promise((res) => c.toBlob(res, "image/png"));
  const file = new File([blob], `record-${Date.now()}.png`, { type: "image/png" });
  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({ files: [file], title: "Nouveau record GymTrack 💪" });
      return "shared";
    } catch (e) {
      if (e.name === "AbortError") return "cancelled";
    }
  }
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
  return "downloaded";
}
